export enum Role {
    SysAdmin = 'SysAdmin',
    CustodiaDev = 'CustodiaDev',
}

export type DbRole = 'full-admin';
